import refs from '../helpers/refs'

class COutOfStock {
  constructor (el) {
    this.hero = el
    this.$refs = refs(this.hero)

    this.init()
  }

  init () {
    this.$refs.closeOverlay.addEventListener('click', (e) => {
      e.path[3].classList.replace('flex', 'hidden')
    })
  }
}

window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-out-of-stock]')
    .forEach(el => new COutOfStock(el))
})
